import { ProjectThirdStage } from "../models/project-third-stage";
import { fetchFile, fetchData } from "../utils/fetchData";

interface fetchProjectThirdStageProps{
    projectId: string,
}

export async function fetchProjectThirdStage(requestProps: fetchProjectThirdStageProps): Promise<ProjectThirdStage> {
    const response = await fetchData("/api/project-third-stages/"+requestProps.projectId, { method: "GET" });
    return response.json();
}

export async function fetchProjectThirdStageFile(requestProps: fetchProjectThirdStageProps){
    await fetchFile("/api/project-third-stages/"+requestProps.projectId+"/file/", { method: "GET" });
}

interface postProjectThirdStageProps{
    projectId: string,
    status: string,
    text: string,
    file: File,
}

export async function postProjectThirdStage(requestProps: postProjectThirdStageProps): Promise<ProjectThirdStage> {
    const formData = new FormData();
    formData.append("projectId", requestProps.projectId);
    formData.append("status", requestProps.status);
    formData.append("text", requestProps.text);
    formData.append("projectthirdstage", requestProps.file);
    const response = await fetchData("/api/project-third-stages/",
    {
        method: "POST",
        body: formData,
    });
    return response.json();
}

interface updateProjectThirdStageStatusProps{
    status: string
}

export async function updateProjectThirdStageStatus(requestProps: updateProjectThirdStageStatusProps, projectId: string): Promise<ProjectThirdStage> {
    const response = await fetchData("/api/project-third-stages/"+projectId,
    {
        method: "PATCH",
        headers: {
            "Content-type": "application/json",
        },
        body: JSON.stringify(requestProps),
    });
    return response.json();
}